import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { TAdmin } from '@/types/admin';

export const useAdminStore = defineStore('admin', () => {
  const admin = ref<TAdmin>({} as TAdmin);

  const permission = computed(() => {
    return admin.value?.permissions ?? [];
  })

  return {
    admin,
    permission
  };
});
